module.exports = __webpack_public_path__ + "img/content-img4_2.e4812421.png";